import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Homepage from './components/Homepage';
import Events from './components/Events';
import Chat from './components/Chat';
import Profile from './components/Profile';
import Login from './components/Auth/Login';
import Signup from './components/Auth/SignUp';
import EmailConfirmation from './components/Auth/EmailConfirmation';
import PrivacyPolicy from './components/PrivacyPolicy';
import CrisisResources from './components/CrisisResources';
import TermsOfService from './components/TermsOfService';
import DeStress from './components/DeStress';
import Community from './components/Community';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/events" element={<Events />} />
            <Route path="/team" element={<Community />} />
            <Route path="/community" element={<Navigate to="/team" replace />} />
            <Route path="/partners" element={<Navigate to="/team#partners" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/confirm-email" element={<EmailConfirmation />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/crisis" element={<CrisisResources />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/apply" element={<Navigate to="/team#join" replace />} />
            <Route path="/destress" element={<DeStress />} />
            <Route
              path="/chat"
              element={
                <ProtectedRoute>
                  <Chat />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
